import React from 'react';
import PropTypes from 'prop-types';
import { Box, Link } from '@availity/element';
import { getSpecificEnv } from '@availity/env-var';

import { JOURNEY_UPDATE_PASSWORD } from './fr-constants';

// for bulding out manual logout url
const specificEnv = getSpecificEnv();
const nonProdUrlPrefix = `${specificEnv}-`;
const { host = '' } = window.location;
const lowercaseHost = host?.toLowerCase();
const hasDotNet = lowercaseHost.indexOf('.net') >= 0;

const logoutUrl = `https://${(specificEnv !== 'prod' && nonProdUrlPrefix) || ''}apps.availity${
  hasDotNet ? '.net' : '.com'
}/web/onboarding/availity-fr-ui/#/logout`;

const LoginErrorBody = ({ setMessages, code }) => {
  const body =
    code === '101' ? (
      <Box>
        <Box mb={2}>The user ID / Password combination was not recognized.</Box>
        <Box>Verify your user ID and password and try again.</Box>
      </Box>
    ) : (
      <Box>
        Your account may be locked.{' '}
        <Link
          href="#/forgot-password"
          loadApp={false}
          onClick={() => {
            setMessages([]);
          }}
        >
          Reset your password
        </Link>{' '}
        or contact your administrator.
      </Box>
    );

  return <Box>{body}</Box>;
};

LoginErrorBody.propTypes = {
  setMessages: PropTypes.func.isRequired,
  code: PropTypes.string.isRequired,
};

const loginError = (setMessages, code) => ({
  key: 'loginError',
  icon: 'icon-attention-circle',
  text: <LoginErrorBody setMessages={setMessages} code={code} />,
  dismissible: true,
});

// currently contains all the known error codes returned by FR. may need to add more to this function if more errors pop up.
export default function parseErrorCode(code, setMessages, journeyId) {
  let output;
  switch (code) {
    case '101':
    case '102':
    case '103':
    case '104': {
      output =
        journeyId === JOURNEY_UPDATE_PASSWORD
          ? 'Invalid current password. Please try again.'
          : loginError(setMessages, code);
      break;
    }
    case '105': {
      output =
        'Your password does not meet our security requirements. Check that you have not entered a previous password and try again.';
      break;
    }
    case '106': {
      output = 'Enter a valid code.';
      break;
    }
    case '108':
    case 'Unable to resume session. It may have expired.': {
      // most of the time 108 will not return and this will come back instead.
      output = 'Your link has expired. Please try again with your most recent link.';
      break;
    }
    case '109': {
      output = 'The email address you entered is not valid. Please try again.';
      break;
    }
    case '110': {
      output =
        'This phone number is already registered with this account. Enter a different number if you want to enroll a second device.';
      break;
    }
    case '111': {
      // handle log out scenario - and pass in the error code through query params
      window.top.location.href = `${logoutUrl}?errorCode=111`;
      break;
    }
    default:
  }

  return output;
}
